import React from 'react'
import './Preloader.css'

const Preloader = () => {
  return (
    <div className="container middle" id="full-page-spinner">
      <p className="loading-text">Loading...</p>
      <div id="preloader">
        <div id="loader"></div>
      </div>
    </div>
  )
}

export default Preloader
